"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplyToDelete = exports.Reply = exports.ReplyId = exports.UpdatedBody = exports.UpdatedTitle = exports.Title = exports.ParticipantId = void 0;
const common_1 = require("./common");
const types_1 = require("@polkadot/types");
class ParticipantId extends common_1.MemberId {
}
exports.ParticipantId = ParticipantId;
class Title extends types_1.Text {
}
exports.Title = Title;
class UpdatedTitle extends types_1.Option.with(types_1.Text) {
}
exports.UpdatedTitle = UpdatedTitle;
class UpdatedBody extends types_1.Option.with(types_1.Text) {
}
exports.UpdatedBody = UpdatedBody;
class ReplyId extends types_1.u64 {
}
exports.ReplyId = ReplyId;
class Reply extends (0, common_1.JoyStructDecorated)({
    text_hash: common_1.Hash,
    owner: ParticipantId,
    parent_id: common_1.PostId,
}) {
}
exports.Reply = Reply;
class ReplyToDelete extends (0, common_1.JoyStructDecorated)({
    post_id: common_1.PostId,
    reply_id: ReplyId,
    hide: types_1.bool,
}) {
}
exports.ReplyToDelete = ReplyToDelete;
exports.default = {
    ParticipantId,
    Title,
    UpdatedTitle,
    UpdatedBody,
    ReplyId,
    Reply,
    ReplyToDelete,
};
